import type { OutcomeKind } from "../../../types";
import type { OutcomeToDisplay } from "../types";

export function createEmptyOutcome(ctid: number, outcomeKind: OutcomeKind, name: string): OutcomeToDisplay {
    return {
        outcome: {
            oid: 0,
            ctid: ctid,
            kind: outcomeKind,
            value: 0,
            params: [],
            tags: {},
        },
        name: name,
        paramsMap: new Map(),
    };
}
